import React from 'react';
import PropTypes from 'prop-types';
import { Eye } from 'lucide-react';
import styles from './PortfolioPreviewBar.module.scss';

const PortfolioPreviewBar = ({ onExit }) => (
  <div className={styles.bar} role="status">
    <Eye size={16} strokeWidth={2} aria-hidden="true" />
    <span>
      You&apos;re viewing your portfolio as a client.{' '}
      <button type="button" className={styles.exit} onClick={onExit}>
        Back to editing
      </button>
    </span>
  </div>
);

PortfolioPreviewBar.propTypes = {
  onExit: PropTypes.func.isRequired,
};

export default PortfolioPreviewBar;
